<template>
  <v-dialog ref="inputDate" v-model="Dialog" offset-y width="290px" transition="scale-transition" :disabled="disabled">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        :color="colordate"
        ref="textfielddata"
        readonly
        v-on="on"
        class="centered-input mx-2 date-input"
        :class="leftAlignInput ? '' : 'centered-input'"
        @keyup.left.native="addDate(-1)"
        @keyup.right.native="addDate(1)"
        @keyup.up.native="addMonth(1)"
        @keyup.down.native="addMonth(-1)"
      >
        <template slot="prepend-inner">
          <v-tooltip bottom color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-icon v-on="on" large @click="addDate(-1)" :style="{ cursor: 'pointer' }">mdi-arrow-left</v-icon>
            </template>
            <span v-if="format == 'date'">{{ $t("prevDay") }}</span>
            <span v-else>{{ $t("prevMonth") }}</span>
          </v-tooltip>
        </template>
        <template slot="append">
          <v-tooltip bottom color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-icon v-on="on" large @click="addDate(1)" :style="{ cursor: 'pointer' }">mdi-arrow-right</v-icon>
            </template>
            <span v-if="format == 'date'">{{ $t("nextDay") }}</span>
            <span v-else>{{ $t("nextMonth") }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
      <v-row v-if="format == 'date' && showDayName" justify="center" align="center" no-gutters>
        <p style="font-size: 12px" class="pa-0 ma-0">
          {{ $moment(mydate).locale($vuetify.lang.current).format("dddd") }}
        </p>
      </v-row>
      <v-row v-else-if="format == 'month' && showDayName" justify="center" align="center" no-gutters>
        <p style="font-size: 12px" class="pa-0 ma-0">
          {{ $moment(mydate).locale($vuetify.lang.current).format("MMMM") }}
        </p>
      </v-row>
    </template>
    <v-card :color="colordate">
      <v-card-title v-if="textup != ''">
        <v-layout align-start justify-center row>
          <h2 style="color: white">{{ textup }}</h2>
        </v-layout>
      </v-card-title>
      <v-card-text class="pa-1">
        <v-date-picker
          v-model="mydate"
          :color="colordate"
          :min="min"
          :max="max"
          :events="functionEvents"
          :allowed-dates="allowedDates"
          width="auto"
          @input="closeDialog()"
          @change="closeDialog()"
          :first-day-of-week="1"
          :locale="$vuetify.lang.current"
          :type="format"
          :picker-date.sync="pickerMonth"
        >
          <v-container class="pa-0" v-if="userId != null">
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="2">
                    <v-icon color="green">mdi-circle-medium</v-icon>
                  </v-col>
                  <v-col cols="1">
                    {{ " - " }}
                  </v-col>
                  <v-col cols="9">
                    {{ $t("workDay") }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="2">
                    <v-icon color="red">mdi-circle-medium</v-icon>
                  </v-col>
                  <v-col cols="1">
                    {{ " - " }}
                  </v-col>
                  <v-col cols="9">
                    {{ $t("publicHoliday") }}
                  </v-col>
                </v-row>
                <div v-for="item in absenceReasons" :key="item.id">
                  <v-row v-if="item.deleted == 0" no-gutters>
                    <v-col cols="2"><v-icon :color="item.Farbcode">mdi-circle-medium</v-icon></v-col>
                    <v-col cols="1">{{ " - " }}</v-col>
                    <v-col cols="9">{{ $t(item.name) }}</v-col>
                  </v-row>
                </div>
                <v-row no-gutters>
                  <v-col cols="12" class="py-0">
                    <v-row style="justify-content: flex-end">
                      <v-btn text @click="closeDialog()">OK</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-date-picker>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "DatePicker",
  data: () => ({
    //mydate: this.mydate1,
    mydate: "",
    tempmydate: "",
    dateFormatted: "",
    colordate: "primary",
    Dialog: false,
    hintMessage: "",
    events: [],
    pickerMonth: null,
    loaderOverlay: null
  }),
  computed: {
    ...mapGetters({
      absenceReasons: "server/absences",
      bookinglinesForMonth: "bookingLines/monthBookingLines",
      absences: "absences/absences"
    })
  },
  props: {
    mydate1: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    textup: {
      type: String,
      default: ""
    },
    hidemytimefield: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: String,
      default: ""
    },
    max: {
      type: String,
      default: ""
    },
    notcurentdate: {
      //notcurentdate = true -> zukunft datum erlaubt eingeben
      type: Boolean,
      default: false
    },
    format: {
      //date, month
      type: String,
      default: "date"
    },
    allowedDates: {
      type: Function,
      default: null
    },
    allowFutureDates: {
      type: Boolean,
      default: null
    },
    showDayName: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    leftAlignInput: {
      type: Boolean,
      default: false
    },
    userId: String,
    userState: String
  },
  model: {
    prop: "mydate1",
    event: "change"
  },
  async created() {
    await this.initialize();
    if (this.absenceReasons.length == 0) {
      this.$store
        .dispatch("server/getAbsenceReasons")
        .then(() => {})
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data);
          }
        });
    }
  },
  methods: {
    async initialize() {
      //this.max = this.maxDate
      this.mydate = this.mydate1;
      this.dateFormatted = this.formatDate(this.mydate1);
    },
    closeDialog() {
      if (this.mydate.length == 7) {
        this.mydate += "-01";
      }
      this.Dialog = false;
      this.tempmydate = this.mydate;
      this.$emit("change", this.mydate);
      this.$emit("next");
    },
    addDate(count) {
      if (Math.sign(count) == 1)
        // Positive
        this.$emit("nextDate");
      else if (Math.sign(count) == -1)
        // negative
        this.$emit("prevDate");
      if (this.format == "date") {
        this.addDays2Date(count);
      } else if (this.format == "month") {
        this.addMonth(count);
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.format == "date") {
        return `${day}.${month}.${year}`;
      } else if (this.format == "month") {
        return `${month}.${year}`;
      }
    },
    addDays2Date(countday) {
      const [year, month, day] = this.mydate.split("-");
      var days = Helper.convDate2Day(parseInt(year), parseInt(month), parseInt(day));
      days += countday;
      //this.mydate = Helper.convDay2Date(days);
      this.mydate = moment(this.mydate).add(countday, "days").format("YYYY-MM-DD");

      //this.dateFormatted = this.formatDate(this.mydate);
      this.checkMinMaxDate();
      //this.setMaxDateWH();
    },
    addMonth(countMonth) {
      let momentDate = this.$moment(this.mydate).startOf("month").format("YYYY-MM-DD");

      this.mydate = moment(this.mydate).add(countMonth, "month").format("YYYY-MM-DD");
      //this.mydate = Helper.addMonth2Date(momentDate, countMonth);
      this.checkMinMaxDate();
    },
    checkMinMaxDate() {
      var currentDate = this.setCurrentDateYearMonthDayAsString();
      if (this.mydate > currentDate && !this.notcurentdate && !this.allowFutureDates) {
        this.$eventHub.$emit("showError", this.$t("dateInFuture"));
        this.mydate = currentDate;
        //this.dateFormatted = this.formatDate(this.dateWH);
      } else if (this.mydate < this.min && this.min != "") {
        this.addDays2Date(1);
        //this.mydate = currentDate;
        //this.mydate = this.max;
      } else if (this.mydate > this.max && this.max != "") {
        this.addDays2Date(-1);
      }
      this.closeDialog();
    },
    setCurrentDateYearMonthDayAsString() {
      var date = new Date();
      var day = Helper.addZeroBehind10(date.getDate());
      var month = Helper.addZeroBehind10(date.getMonth() + 1);
      var year = date.getFullYear();
      var currentDate = year + "-" + month + "-" + day;
      return currentDate;
    },
    changehintMessage() {
      // Functioniert nicht
      if (this.mydate != null || this.mydate != "") {
        var newDate = new Date(this.mydate);
        var day = Helper.getCurrentDayOfWeek(newDate.getDay());
        var date = newDate.getDate();
        var month = Helper.getCurrentMonthName(newDate.getMonth());
        var year = newDate.getFullYear();
        if (this.format == "date") {
          this.hintMessage = day + ", " + date + " " + month + " " + year;
        } else {
          this.hintMessage = month + " " + year;
        }
      } else {
        this.hintMessage = "";
      }
    },
    functionEvents(date) {
      for (let line of this.events) {
        if (line.date == date && line.type == "work") return ["green"];
        else if (line.date == date && line.type == "holiday") return ["red"];
        else if (line.date == date && this.absenceReasons.some((item) => item.id == line.absenceId)) {
          let { Farbcode } = this.absenceReasons.find((item) => item.id == line.absenceId);
          return [Farbcode];
        }
      }
      return false;
    },
    async getBookingLinesForMonth() {
      if (this.userId != null) {
        let data = {
          id: this.userId,
          date: this.$moment(this.pickerMonth, "YYYY-MM").format("YYYY-MM-DD")
        };
        await this.$store
          .dispatch("bookingLines/getBookingLinesForMonth", data)
          .then(() => {
            if (this.bookinglinesForMonth.bookingLines.length != 0)
              for (let line of this.bookinglinesForMonth.bookingLines) {
                if (line.workTimeInMinutes != 0) this.events.push({ date: line.date, type: "work" });
              }
          })
          .catch((err) => {
            if (err.response.status != 200) {
              this.$eventHub.$emit("showError", err.response.data, "bottom", "right");
            }
          });
      }
    },
    async getHolidays() {
      return await this.$store
        .dispatch("holidayInfo/getPublicHolidaysForYear", this.pickerMonth.substring(0, 4))
        .then((res) => {
          if (res.status == 200) {
            for (let holiday of res.data.holidays) {
              if (holiday.state == this.userState) this.events.push({ date: holiday.date, type: "holiday", state: holiday.state });
            }
          }
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    async getAbsenceInfoForEmployeeID() {
      await this.$store
        .dispatch("absences/getAbsences", {
          userId: this.userId,
          date: this.$moment(this.pickerMonth, "YYYY-MM").format("YYYY-MM-DD")
        })
        .then(() => {
          for (let absence of this.absences) {
            this.events.push(absence);
          }
        });
    }
  },
  watch: {
    userId: async function (val) {
      if (val != null && this.pickerMonth != null) {
        this.loaderOverlay = true;
        this.events = [];
        await this.getBookingLinesForMonth();
        await this.getHolidays();
        await this.getAbsenceInfoForEmployeeID();
        this.$emit("monthChanged", this.events);
        this.loaderOverlay = false;
      }
    },
    mydate1() {
      if (this.tempmydate != this.mydate1) {
        this.mydate = this.mydate1;
      }
    },
    pickerMonth: async function (val) {
      this.loaderOverlay = true;
      this.events = [];
      if (this.userId != null) {
        await this.getBookingLinesForMonth();
        await this.getHolidays();
        await this.getAbsenceInfoForEmployeeID();
        this.$emit("monthChanged", this.events);
      }
      this.loaderOverlay = false;
    },
    mydate() {
      this.dateFormatted = this.formatDate(this.mydate);
      //this.changehintMessage();
      var currentDate = this.setCurrentDateYearMonthDayAsString();
      if (this.mydate > currentDate && !this.notcurentdate && !this.allowFutureDates) {
        this.$eventHub.$emit("showError", this.$t("dateInFuture"));
        this.mydate = currentDate;
        //this.dateFormatted = this.formatDate(this.dateWH);
      }
    },
    Dialog() {
      if (!this.Dialog) {
        this.$nextTick(() => {
          this.$refs.textfielddata.focus();
        });
      }
    }
  }
};
//@ sourceURL=datePicker.js
</script>

<style scoped>
.date-input >>> .v-label {
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
}
.date-input >>> input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
